/* @ngInject */
class Status {
	constructor(STATUSES) {
		this.STATUSES = STATUSES;
	}

	isUnloaded(status) {
		return status === this.STATUSES.UNLOADED;
	}

	isLoading(status) {
		return status === this.STATUSES.LOADING;
	}

	isLoaded(status) {
		return status === this.STATUSES.LOADED;
	}

	isErrored(status) {
		return status === this.STATUSES.ERRORED;
	}
}

export default Status;


// WEBPACK FOOTER //
// ./src/js/services/status/index.js